import workerUrl from "pdfjs-dist/legacy/build/pdf.worker.min.mjs?url";
import type { PDFDocumentLoadingTask } from "pdfjs-dist";

/** Only load PDF.js in the browser, not while server-rendering settings.
 * Vite bundles the matching worker locally, respecting the artifact base path.
 * The compatibility build supplies APIs such as Promise.withResolvers that
 * older Safari/WebKit browsers lack. Keep the API and worker builds paired. */
export async function createPdfPreviewTask(data: Uint8Array): Promise<PDFDocumentLoadingTask> {
  const pdfjs = await import("pdfjs-dist/legacy/build/pdf.mjs");
  pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;
  return pdfjs.getDocument({ data, isEvalSupported: false, useSystemFonts: true });
}
